import { contents } from '../../data/contents';
import listStyles from '../../style/styles/Display.module.scss';
import { useChatStateStore, useChatbotStore } from '../../zustand/store';
import { LayoutModeEnum } from '../../type/modeState.type';

export const ProductInfoTypeVertical = (props) => {
    const { product, type } = props;
    const { language, layoutMode } = useChatStateStore();
    const { chatbot } = useChatbotStore();
    switch (type) {
        case 0: // default
            return (
                <div className={listStyles.ProductList__productInfoContainer}>
                    <div className={listStyles.ProductList__productHeader}>
                        <p className={`fc-gray-800 h9 ${layoutMode === LayoutModeEnum.MODAL ? 'line-clamp-1' : 'line-clamp-2'}`}>{product?.name}</p>
                    </div>
                    <div className='spacing-2' />
                    {
                        chatbot.isCarouselPriceVisible ?
                        <div className={listStyles.ProductList__productDetails}>
                            {
                                product?.discount > 0 &&
                                <>
                                    <div className={listStyles.ProductList__discountRate}>{product?.discount?.toLocaleString()}%</div>
                                    <div className='spacing-2' />
                                </>
                            }
                            <div className={listStyles.ProductList__price}>{contents.carousel[language].priceUnit}{product?.price?.toLocaleString()}</div>
                        </div> :
                        <div className='spacing-20' />
                    }
                </div>
            )
        case 1: // fastfive
            return (
                <div className={listStyles.ProductList__productInfoContainer}>
                    <div className={listStyles.ProductList__productHeader}>
                        <p className={`fc-gray-800 h8 ${layoutMode === LayoutModeEnum.MODAL ? 'line-clamp-1' : 'line-clamp-2'}`}>{product?.name}</p>
                    </div>
                    <div className='spacing-2' />
                    <div className={listStyles.ProductList__productDetails}>
                        <p className={`fc-gray-500 h9 ${layoutMode === LayoutModeEnum.MODAL ? 'line-clamp-1' : 'line-clamp-2'}`}>{product?.shortDesc}</p>
                    </div>
                </div>
            )
        default:
            return (
                <div className={listStyles.ProductList__productInfoContainer}>
                    <div className={listStyles.ProductList__productHeader}>
                        <p className={`fc-gray-800 h9 ${layoutMode === LayoutModeEnum.MODAL ? 'line-clamp-1' : 'line-clamp-2'}`}>{product?.name}</p>
                    </div>
                    <div className='spacing-2' />
                    {
                        chatbot?.isCarouselPriceVisible ?
                        <div className={listStyles.ProductList__productDetails}>
                            {
                                product?.discount > 0 &&
                                <>
                                    <div className={listStyles.ProductList__discountRate}>{product?.discount?.toLocaleString()}%</div>
                                    <div className='spacing-2' />
                                </>
                            }
                            <div className={listStyles.ProductList__price}>{contents.carousel[language].priceUnit}{product?.price?.toLocaleString()}</div>
                        </div> :
                        <div className='spacing-20' />
                    }
                </div>
            )
    }
}

export const ProductInfoTypeHorizontal = (props) => {
    const { product, type } = props;
    const { language } = useChatStateStore();
    const { chatbot } = useChatbotStore();
    switch (type) {
        default:
            return (
                <div className={listStyles.ProductList__productInfoContainer}>
                    <div className={listStyles.ProductList__productHeader}>
                        <p className={`fc-gray-800 h9 line-clamp-1`}>{product?.name}</p>
                    </div>
                    <div className='spacing-4' />
                    <div className={listStyles.ProductList__productDetails}>
                        {
                            chatbot?.isCarouselPriceVisible ?
                            <>
                                {
                                    product?.discount > 0 &&
                                    <>
                                        <div className={listStyles.ProductList__discountRate}>{product?.discount?.toLocaleString()}%</div>
                                        <div className='spacing-2' />
                                    </>
                                }
                                <div className={listStyles.ProductList__price}>{contents.carousel[language].priceUnit}{product?.price?.toLocaleString()}</div>
                                <div className='spacing-8' />
                            </> :
                            null
                        }
                        <img src='/img/units/star-gray-300.png' width={14} height={14} alt='star' />
                        <div className='spacing-2' />
                        <p className='h9 fc-gray-500'>{product?.rate.toFixed(1)}</p>
                        <div className='spacing-4' />
                        {
                            product.reviewNum > 0 ?
                            <>
                                <p className='h9 fc-gray-500'>{contents.carousel[language].review}{' '}{product?.reviewNum}</p>
                            </> :
                            <>
                                <p className='h9 fc-gray-500'>{contents.carousel[language].new}</p>
                            </>
                        }
                    </div>
                </div>
            )
    }
}